import { Button, message, Table, Flex } from 'antd'
import { useEffect, useState } from 'react'
import { downloadFile, getFileUrl } from '@/utils/FileUtil';
const ResourceDownload = ({ files }) => {

    const [messageApi, contextHolder] = message.useMessage();
    const [fileInfos, setFileInfos] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);

    useEffect(() => {
        parseFileUrls();
    }, [files])

    const parseFileUrls = async () => {
        let infos = JSON.parse(JSON.stringify(files || []))
        if (!infos) {
            return
        }
        for (let file of infos) {
            file.downloadUrl = await getFileUrl(file.filePath)
        }
        setFileInfos(infos)
    }

    const onSelectChange = (selectedRowKeys, selectedRows) => {
        setSelectedRowKeys(selectedRowKeys);
        setSelectedRows(selectedRows);
    };

    const columns = [
        {
            title: '文件名',
            dataIndex: 'fileName',
            key: 'fileName',
        },
        {
            title: '文件大小',
            dataIndex: 'fileSize',
            key: 'fileSize',
        },
        {
            title: '更新时间',
            dataIndex: 'createTime',
            key: 'createTime',
        },
        {
            title: '操作',
            dataIndex: 'action',
            key: 'action',
            render: (_, record) => (
                <Button type="primary" onClick={() => { downloadFile(record.downloadUrl, record.fileName) }}>下载</Button>
            ),
        },
    ]

    const download = () => {
        if (!selectedRows.length) {
            messageApi.error("请选择要下载的资源")
            return
        }
        for (const file of selectedRows) {
            try {
                downloadFile(file.downloadUrl, file.fileName)
            } catch (e) {
                messageApi.error("下载资源失败：" + e.message)
            }
        }
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            {contextHolder}
            <Flex gap="middle" vertical>
                <Flex align="center" gap="middle">
                    <Button type="primary" onClick={download} disabled={selectedRowKeys.length <= 0} >
                        下载
                    </Button>
                    {`选中 ${selectedRowKeys.length} 项`}
                </Flex>
                <Table
                    rowKey={'id'}
                    style={{ overflowY: 'auto', height: '100%' }}
                    rowSelection={{
                        selectedRowKeys,
                        onChange: onSelectChange,
                    }}
                    pagination={false}
                    columns={columns} dataSource={fileInfos} />
            </Flex>
        </div >
    );
}
export default ResourceDownload;